import { render } from "./ClassFormModal.vue?vue&type=template&id=b3f56594&scoped=true&ts=true"
import script from "./ClassFormModal.vue?vue&type=script&lang=ts"
export * from "./ClassFormModal.vue?vue&type=script&lang=ts"

import "./ClassFormModal.vue?vue&type=style&index=0&id=b3f56594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f56594"]])

export default __exports__